import Backbone from '@rover/globals/backbone';
import Rover from '@rover/globals/Rover';
import _ from '@rover/globals/underscore';
import dataLayer from '@rover/globals/dataLayer';

export default Backbone.View.extend({
  events: {
    'click .js-quick-view-button': 'showQuickView',
  },

  initialize(options) {
    this.rank = options.rank;
    this.service_type = options.service_type;

    // Highlight map markers on hover
    this.$el.on('mouseover', _.bind(this.onMouseover, this));
    this.$el.on('mouseout', _.bind(this.onMouseout, this));

    // Scroll highlight hovered markers
    Rover.pubSub.on(this.sitterHighlightEvent(), _.bind(this.onSitterHighlight, this));

    // Scroll to sitter when selected
    Rover.pubSub.on(this.sitterSelectedEvent(), _.bind(this.onSitterSelected, this));

    // Initialize the popover
    Rover.stickyPopover(this.$('.js-badge-popover'), {
      container: 'body',
      placement: 'top',
      tracking: true,
    });

    // Initialize the popover
    this.$('.js-person-video-callout').popover();

    // Initialize the debug data button
    if (this.$('.popover-debug-data-button')) {
      this.$('.popover-debug-data-button button').popover();
    }

    // Handle clicks on the sitter card
    this.$el.click(_.bind(this.onSitterCardClicked, this));
    this.$el.find('.js-profile-link-more').click(_.bind(this.fireEvent, this, 'search-more'));
    this.$el.find('.js-rover-icon-in-heart').click(_.bind(this.fireEvent, this, 'search-heart'));
    this.$el.find('.js-profile-link-sitter-name').click(_.bind(this.recordSearchSitterName, this));
    this.$el.find('.js-price-wrap').click(_.bind(this.fireEvent, this, 'search-price'));
    this.$el
      .find('.js-repeat-clients')
      .click(_.bind(this.fireEvent, this, 'search-repeat-clients'));
    this.$el.find('.js-reviews').click(_.bind(this.fireEvent, this, 'search-reviews'));
  },

  sitterHighlightEvent() {
    return ['sitter', 'highlight', this.service_type, this.rank].join(':');
  },

  sitterSelectedEvent() {
    return ['sitter', 'selected', this.service_type, this.rank].join(':');
  },

  sitterShowOnMapEvent() {
    return ['sitter', 'showOnMap', this.service_type, this.rank].join(':');
  },

  markerHighlightEvent() {
    return ['marker', 'highlight', this.service_type, this.rank].join(':');
  },

  destroyView() {
    // COMPLETELY UNBIND THE VIEW
    this.undelegateEvents();

    this.$el.removeData().unbind();

    // Remove custom events
    Rover.pubSub.off(this.sitterHighlightEvent());
    Rover.pubSub.off(this.sitterSelectedEvent());

    // Remove view from DOM
    this.remove();
    Backbone.View.prototype.remove.call(this);
  },

  onSitterHighlight(highlight) {
    if (highlight) {
      this.$el.addClass('active');
    } else {
      this.$el.removeClass('active');
    }
  },

  onSitterCardClicked() {
    Rover.pubSub.trigger(this.sitterShowOnMapEvent(), true);
  },

  onSitterSelected() {
    this.scrollToThis();
  },

  scrollToThis() {
    const scrollTop = this.$el.offset().top;
    Rover.pubSub.trigger('scroll:topOfResults', scrollTop);
  },

  onMouseover() {
    Rover.pubSub.trigger(this.markerHighlightEvent(), true);
  },

  onMouseout() {
    Rover.pubSub.trigger(this.markerHighlightEvent(), false);
  },

  showQuickView() {
    dataLayer.push({
      event: 'search-quickview',
      providerId: this.model.get('person_opk'),
    });
    Rover.pubSub.trigger(`sitterCard:show:${this.model.get('service_pk')}`);
  },

  recordSearchSitterName() {
    dataLayer.push({
      event: 'search-sitter-name',
      providerId: this.model.get('person_opk'),
    });
  },

  fireEvent(eventName) {
    dataLayer.push({
      event: eventName,
      providerId: this.model.get('person_opk'),
    });
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/sitter_card_view.js